<template xmlns:vertical-align="http://www.w3.org/1999/xhtml">
    <div :class="$style.container"
         v-loading.fullscreen.lock.body="loading"
         element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)">
        <div style="width: 100%">
            <el-button-group :class="$style.month" class="a_modal">
                <el-button size="small" icon="el-icon-arrow-left" @click.stop="lastNextMonthClick(-1)"></el-button>
                <el-button size="small" disabled>{{dateStr}}</el-button>
                <el-button size="small" icon="el-icon-arrow-right" @click.stop="lastNextMonthClick(1)"></el-button>
            </el-button-group>
        </div>

        <div style="width: 100%">

            <el-row style="margin-bottom: 15px;margin-top: 5px">
                <el-col :span="12" :class="$style.text">
                    <div class="grid-content bg-purple" align="center">
                        <img :src="late_img" width="16px" style="margin-left: 5px;margin-right: 5px;vertical-align: middle">
                        <span >迟到:</span>
                        <span :class="$style.span_color">{{late}}</span>
                        <span :class="$style.span">次</span>
                        <span :class="$style.span_color">{{late_time}}</span>
                        <span :class="$style.span">分钟</span>

                        <span style="margin-left: 5px">早退:</span>
                        <span :class="$style.span_color">{{leave}}</span>
                        <span :class="$style.span">次</span>
                        <span :class="$style.span_color">{{leave_time}}</span>
                        <span :class="$style.span">分钟</span>
                    </div>
                </el-col>
                <el-col :span="12" :class="$style.text">
                    <div class="grid-content bg-purple-light" align="center">
                        <img :src="absence_img" width="16px" style="margin-left: 5px;margin-right: 5px;vertical-align: middle">
                        <span>缺勤:</span>
                        <span :class="$style.span_color">{{absence_data}}</span>
                        <span :class="$style.span">小时</span>

                        <img :src="leave_img" width="16px" style="margin-left: 5px;margin-right: 5px;vertical-align: middle">
                        <span>请假:</span>
                        <span style="color: #7ED321">{{leave_data}}</span>
                        <span :class="$style.span">小时</span>

                        <img :src="ot_img" width="16px" style="margin-left: 5px;margin-right: 5px;vertical-align: middle">
                        <span >加班:</span>
                        <span style="color: #4A90E2">{{ot_data}}</span>
                        <span :class="$style.span">小时</span>

                    </div>
                </el-col>
            </el-row>


        </div>
        <el-table
                :data="tableData"
                style="width: 100%"
                :header-cell-style="tableHeaderColor">

            <el-table-column type="expand">
                <template slot-scope="props">

                    <el-form label-position="left" inline class="demo-table-expand">

                        <el-form-item v-show="props.row.Child.length === 0">
                            <span>暂无排班</span>
                        </el-form-item>

                        <el-col v-for="(item, index) in props.row.Child" :key="index" :label="item" :span="8" v-show="props.row.Child.length !== 0">
                            <el-form-item>
                                <div class="channel">

                                    <div style="text-align: center">
                                        <span>{{item.schedule_date}}</span>
                                        <div style="width:50px;margin-top:-9px;margin-bottom:-9px;padding:0px;overflow:hidden;"></div>
                                        <span :class="$style.span_shift" :style="{'background':getBackground(item.icon_color)}">{{item.icon_text}}</span>
                                    </div>

                                    <div style="margin-left: 10px;margin-right:10px;text-align: center">
                                        <span style="color:#87909A">{{item.last_name}}</span>
                                        <div style="width:50px;margin-top:-9px;margin-bottom:-9px;padding:0px;overflow:hidden;"></div>
                                        <span :style="{'color':getTextColor(item.textStatus)}">{{item.textStatus}}</span>
                                    </div>

                                    <img :src="gps_icon" width="15px" style="margin-right: 5px">

                                    <div>
                                        <span>最早签入：</span>
                                        <span>{{getFirstCheckIn(0,item.first_check_in)}}</span>
                                        <div style="width:50px;margin-top:-9px;margin-bottom:-9px;padding:0px;overflow:hidden;"></div>
                                        <span>最晚签出：</span>
                                        <span>{{getFirstCheckIn(1,item.last_check_out)}}</span>
                                    </div>

                                </div>

                            </el-form-item>

                        </el-col>

                    </el-form>


                </template>
            </el-table-column>
            <el-table-column
                    label="日期"
                    prop="schedule_date"
                    align="center"
                    width="150">
                <template slot-scope="scope">
                    <span style="color: #9B9B9B">{{scope.row.schedule_date}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    label="当班人数"
                    prop="watch"
                    align="center">
                <template slot-scope="scope">
                    <span style="color: #9B9B9B">{{scope.row.watch}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    label="迟到人数"
                    prop="late"
                    align="center">
                <template slot-scope="scope">
                        <span :style="{'color':getTabTextColor(scope.row.late)}">{{scope.row.late}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    label="早退人数"
                    prop="leave"
                    align="center">
                <template slot-scope="scope">
                    <span :style="{'color':getTabTextColor(scope.row.leave)}">{{scope.row.leave}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    label="缺勤人数"
                    prop="absence"
                    align="center">
                <template slot-scope="scope">
                    <span :style="{'color':getTabTextColor(scope.row.absence)}">{{scope.row.absence}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    label="请假人数"
                    prop="vacation"
                    align="center">
                <template slot-scope="scope">
                    <span :style="{'color':getTabTextColor(scope.row.vacation)}">{{scope.row.vacation}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    label="加班人数"
                    prop="ot"
                    align="center">
                <template slot-scope="scope">
                    <span :style="{'color':getTabTextColor(scope.row.ot)}">{{scope.row.ot}}</span>
                </template>
            </el-table-column>


        </el-table>

    </div>
</template>
<script>
    import Pagination from '../../../../components/pagination'
    import http from '../../../../APIService/http'
    import ElMenu from "element-ui/packages/menu/src/menu";
    import late_img from '../../../../assets/images/late_img.png'
    import absence_img from '../../../../assets/images/absence_img.png'
    import leave_img from '../../../../assets/images/leave_img.png'
    import ot_img from '../../../../assets/images/ot_img.png'
    import gps_icon from '../../../../assets/images/gps_icon.png'
    import moment from 'moment'
    import {bus} from '../../../../router/index.js'

    export default {
        data() {
            return {
                id:'',

                late:0,
                late_time:0,
                leave:0,
                leave_time:0,

                absence_data:0,
                leave_data:0,
                ot_data:0,

                dateStr:this.getCurrentDate(),
                late_img:late_img,
                absence_img:absence_img,
                leave_img:leave_img,
                ot_img:ot_img,
                gps_icon:gps_icon,
                tableData: []
            }
        },
        created() {

            this.id = this.$store.getters.getStore.id

            this.getAttendanceResultByday()

            bus.$emit('setDate', this.dateOne)


        },
        props: {
            item: {
                type: Object,
                default: () => {
                }
            },
            index: {
                type: Number,
                default: 0
            },
            dateOne: {
                type: Object
            }
        },
        components: {
            ElMenu,
            Pagination
        },
        methods: {
            getByDay(){
                this.dateStr = this.getCurrentDate()
                this.getAttendanceResultByday ();
            },
            // 初始化页面获取数据
            async getAttendanceResultByday () {
                try {

                    this.loading = true
                    let data = {
                        store_id: this.id,
                        user_id: this.$store.getters.getUser.user_id,
                        tenant_id:this.$store.getters.getUser.tenant_id,
                        month: this.dateOne.format("YYYY-MM"),
                    }

                    await http.post('/wapi/v1/getAttendanceResultByday', data).then(res => {

                        let data = res.data
                        let scheduling_info = res.data.scheduling_info
                        this.late = scheduling_info.late
                        this.late_time = scheduling_info.late_time
                        this.leave = scheduling_info.leave
                        this.leave_time = scheduling_info.leave_time

                        this.absence_data = scheduling_info.absence_hours
                        this.leave_data = scheduling_info.leave_hours
                        this.ot_data = scheduling_info.ot_hours

                        this.tableData = data.schedule_array

                        bus.$emit('setShiftArray', res.data.shiftBArray)

                        this.loading = false


                    })
                } catch (err) {
                    this.loading = false
                    this.error()
                }
            },
            // 修改table header的背景色
            tableHeaderColor({row, column, rowIndex, columnIndex}) {
                if (rowIndex === 0) {
                    return 'background-color: #E0E0E0;color: #5C575E'
                }
            },
            // 修改班次的背景色
            getBackground(color) {
                return 'rgb('+color+')'
            },
            // 修改text颜色
            getTextColor(text) {
                if(text === '正常'){
                    return '#7ED321'
                }else {
                    return '#ED3B3F'
                }

            },
            // 修改表里text颜色
            getTabTextColor(num) {
                if(num === '0' || num === 0){
                    return '#9B9B9B'
                }else {
                    return '#D0021B'
                }

            },
            getCurrentDate(){

                let date = moment(this.dateOne)
                return date.year() + '年' +this.getFormatDate(date.month()+1)+ '月'


            },lastNextMonthClick(num){

                let currentDate =  moment(this.dateOne)
                let date = currentDate.add(num, "months")
                this.dateOne = date
                this.dateStr = date.year() + '年' +this.getFormatDate(date.month()+1)+ '月'

                bus.$emit('setDate', this.dateOne)

                this.getAttendanceResultByday()

            },
            getFormatDate(arg){

                if (!arg) {
                    return '';
                }
                var re = arg + '';
                if (re.length < 2) {
                    re = '0' + re;
                }
                return re;
            },
            getFirstCheckIn(num,check){
                if(num === 0){

                    if(check){
                        return check.substring(check.length-8,check.length)
                    }else {
                        return '尚未签入'
                    }

                }else {
                    if(check){
                        return check.substring(check.length-8,check.length)
                    }else {
                        return '尚未签出'
                    }
                }
            }

        }
    }
</script>
<style lang="scss" module>
    @import '../../../../assets/css/default';
    .container {
        margin: 10px 0px;
        .month {
            margin-left: 40%;
            margin-bottom: 10px;
        }
        .text {
            font-size: 13px;
            color: #4D586D;
        }

        .span{
            display: inline-block;
            font-size: 12px;
            color: #FFFFFF;
            text-align: left;
            padding: 5px;
            background: #9B9B9B;
            border-radius: 3px;
            margin-left: 5px;
            margin-right: 5px;
        }
        .span_shift{
            font-size: 12px;
            color: #FFFFFF;
            border-radius: 3px;
            padding: 4px;
            display:-moz-inline-box;
            display:inline-block;
            text-align:center;
            line-height:15px;
            width:50px;
        }
        .span_color{
            color: #ED3B3F;
        }

        .demo-table-expand {
            font-size: 0;
        }
        .demo-table-expand label {
            width: 90px;
            color: #99a9bf;
        }
        .demo-table-expand .el-form-item {
            margin-right: 0;
            margin-bottom: 0;
            width: 100%;
        }
    }
</style>
<style scoped>

    .a_modal >>> .el-button {
        color: #646464;
    }

    .channel {
        border: solid 1px #87909A;
        padding-left: 5px;
        padding-right: 10px;
        margin-left: -50px;
        font-size: 12px;
        border-radius: 4px;
        color: #B0B5B9;
        min-height: 58px;
        vertical-align: middle;

        /*display: flex;*/
        /*justify-content: space-around;*/
        display: flex;
        align-items: center;
        position: relative;
    }

</style>


// WEBPACK FOOTER //
// src/pages/attendance/statistics/item/dayItem.vue